import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/store";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/entrar", { replace: true }); return; }
    const session_id = decodeURIComponent(m[1]);
    const intent = sessionStorage.getItem("post_login_intent") || "/minha-conta";
    sessionStorage.removeItem("post_login_intent");

    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id });
        localStorage.setItem("eterniza_token", data.token);
        // Clear hash from URL
        window.history.replaceState({}, document.title, window.location.pathname);
        await refresh();
        toast.success(`Olá, ${data.user.name?.split(" ")[0] || "cliente"}!`);
        nav(intent, { replace: true });
      } catch (err) {
        toast.error("Não foi possível autenticar com o Google. Tente novamente.");
        nav("/entrar", { replace: true });
      }
    })();
  }, [location.hash, nav, refresh]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6" data-testid="auth-callback-root">
      <div className="w-12 h-12 rounded-full border-2 border-[#D4AF37] border-t-transparent animate-spin" />
      <div className="mt-6 font-display text-2xl text-[#0D1B2A]">Autenticando…</div>
      <div className="text-sm text-[#6B7280] mt-2">Um momento, estamos finalizando seu acesso.</div>
    </div>
  );
}
